const QUERY_KEYS = {
  FETCH_POINTS_BAGS: 'fetchPots',
  FETCH_POINTS_TRANSACTIONS: 'fetchPointsTransactionsInfinite',
  // add other keys here as you need
};

export default QUERY_KEYS;
